<template>
  <div class="bikelist-container">
    <el-form :model="queryInfo" size="medium" :inline="true">
          <el-form-item :label="$t('bike.name30')"  prop="tenantId">
            <el-cascader ref="refHandle" v-model="tenantIds"  @change="handleChange1" clearable collapse-tags :show-all-levels="false" :props="{ lazy: true, multiple: true, checkStrictly: true, lazyLoad: loadOptions }"></el-cascader>
        </el-form-item>
          <!-- <el-form-item :label="$t('bike.name31')" prop="controllerEdition">
            <el-input v-model="queryInfo.controllerEdition" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item> -->
          <!-- <el-form-item :label="$t('bike.name32')" prop="meterEdition">
            <el-input v-model="queryInfo.meterEdition" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item> -->
          <!-- <el-form-item :label="$t('bike.name33')" prop="iotEdition">
            <el-input v-model="queryInfo.iotEdition" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item> -->
          <el-form-item :label="$t('finance.name33')" prop="ebikeId">
              <el-input v-model="queryInfo.ebikeId" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>

          <el-form-item :label="$t('bike.name295')" prop="ebikeCode">
              <el-input v-model="queryInfo.ebikeCode" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('bike.name35')" prop="status">
            <el-select v-model="queryInfo.status" :placeholder="$t('public.name1')" clearable>
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="getPageList">{{ $t('public.name3') }}</el-button>
            <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
          </el-form-item>
    </el-form>
    <div class="add-user">
      <el-button type="primary" size="medium" @click="importBikeFactoryDialog" v-if="buttonPerms.indexOf('bike/importVehicleFactoryInformation') > -1">{{ $t('bike.name400') }}</el-button>
      <el-button type="primary" size="medium" @click="showAddIotNum" v-if="buttonPerms.indexOf('ebike/tenantBindEbike') > -1">{{ $t('bike.name156') }}</el-button>
      <el-button size="medium" type="primary" @click="exportEbikeData"  :loading='exportLoading'>{{ $t('bike.name159') }}</el-button>
      <el-button type="primary" size="medium" @click="showModeBindDialog" v-if="buttonPerms.indexOf('ebikeModel/bindModel') > -1" >{{ $t('bike.name115') }}</el-button>
      <!-- <el-button type="primary" size="medium" @click="showVersionConfigurationDialog">{{ $t('bike.name118') }}</el-button> -->
      <el-button type="primary" size="medium" @click="changeTransportMode" :loading='loading1' v-if="buttonPerms.indexOf('ebike/sendTransportInfo') > -1">{{ $t('bike.name117') }}</el-button>
      <el-button type="primary" size="medium" @click="showFiveCodeDialog" v-if="buttonPerms.indexOf('ebike/importEbikeVin') > -1">{{ $t('bike.name116') }}</el-button>
      <el-button type="primary" size="medium" @click="showImportIotNum" v-if="buttonPerms.indexOf('ebike/importTenantBindEbike') > -1">{{ $t('bike.name157') }}</el-button>
      <el-button size="medium" type="primary" @click="showIOTDialog" v-if="buttonPerms.indexOf('ebike/importIOT') > -1">{{ $t('bike.name158') }}</el-button>
      <el-button size="medium" type="primary" @click="showAddBikeDialog" v-if="buttonPerms.indexOf('ebike/addBike') > -1">{{ $t('bike.name3') }}</el-button>
      <el-button type="primary" size="medium" @click="importBikeInfoDialog" v-if="buttonPerms.indexOf('bike/importVehicleInformation') > -1">{{ $t('bike.name212') }}</el-button>
      <el-button type="primary" size="medium" @click="importProductDialog" v-if="buttonPerms.indexOf('bike/importProductQualityCertificate') > -1">{{ $t('bike.name213') }}</el-button>
    </div>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="margin-top:15px;">
    <el-tab-pane label="IOT" name="first"></el-tab-pane>
    <el-tab-pane label="单独蓝牙" name="second"></el-tab-pane>
  </el-tabs>
    <el-table ref="table"   :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading" @selection-change="onSelectTab">
      <el-table-column type="selection" width="55" align="center" fixed="left"></el-table-column>
      <el-table-column :label="$t('bike.name38')" prop="ebikeId" sortable min-width="180" fixed="left"></el-table-column>
      <el-table-column :label="$t('bike.name376')" prop="iotVersionNo" sortable min-width="180"></el-table-column>
      <el-table-column :label="$t('bike.name377')" prop="iotHwVersionNo" sortable min-width="180"></el-table-column>
      <el-table-column :label="$t('bike.name105')" prop="tenantName" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.tenantName || '—' }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name40')" prop="mac" sortable min-width="150"></el-table-column>
      <el-table-column :label="$t('bike.name278')" prop="ebikeCode" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.ebikeCode || '—' }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column :label="$t('bike.name43')" prop="controllerVersion" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.controllerVersion || '—' }}</div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name106')" prop="meterNo" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.meterNo || '—' }}</div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column :label="$t('bike.name107')" prop="iotVersionNo" sortable min-width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.iotVersionNo || '—' }}</div>
        </template>
      </el-table-column> -->
      <el-table-column :label="$t('bike.name52')" prop="ebikeModelName" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.ebikeModelName || '—' }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name4')" prop="ebikeModelId" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.ebikeModelId || '—' }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column :label="$t('bike.name108')" prop="ebikeVinNo" sortable min-width="150"></el-table-column> -->
      <el-table-column :label="$t('bike.name109')" prop="motorNo" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.motorNo || '—' }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name307')" prop="controllerNo" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.controllerNo || '—' }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name308')" prop="batteryNo" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.batteryNo || '—' }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name309')" prop="meterNo" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.meterNo || '—' }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="合格证编号" prop="cccCode" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.cccCode || '—' }}</div>
        </template>
      </el-table-column> -->
      <el-table-column :label="$t('bike.name110')" prop="remark" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.remark || '—' }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name111')" prop="isTransport" sortable min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.isTransport === 0 ? $t('bike.name251') : $t('bike.name252') }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name112')" prop="status" sortable min-width="120">
        <template slot-scope="scope">
          <div class="green" v-if="scope.row.status === 1">
            <div class="text">{{ $t('bike.name45') }}</div>
          </div>
          <div class="red" v-if="scope.row.status === 0">
            <div class="text">{{ $t('bike.name113') }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name44')" prop="test" sortable min-width="180">
        <template slot-scope="scope">
          {{ [$t('bike.name251'),$t('bike.name252')][scope.row.isTest] }}
          <!-- <el-switch class="switch" :value="scope.row.isTest" :active-value="1"  :inactive-value="0" active-color="#0f73e6" inactive-color="#dcdfe6"   :active-text="$t('bike.name252')"  :inactive-text="$t('bike.name251')"> </el-switch> -->
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name11')" min-width="200px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="showDetailsDialog(scope.row)" v-if="buttonPerms.indexOf('ebike/findEbikeDetail') > -1">{{ $t('bike.name46') }}</el-button>
          <el-button type="text" @click="showIotDetailsDialog(scope.row)" v-if="buttonPerms.indexOf('ebike/getIotDetalis') > -1">IOT</el-button>
          <el-button type="text" @click="handleCancelBindModel(scope.row)" v-if="buttonPerms.indexOf('ebikeModel/cancelBindModel') > -1">{{ $t('bike.name114') }}</el-button>
          <el-button type="text" @click="showCertificateDialog(scope.row)" v-if="scope.row.eccId">{{ $t('bike.name214') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <!--车型绑定-->
    <el-dialog :title="$t('bike.name120')" :visible.sync="vehicleModelBindingDialog" v-if="vehicleModelBindingDialog" :close-on-click-modal ="false" :before-close="close" width="600px">
      <el-form ref="bindingFormRef" label-width="120px" :model="bindingForm" :rules="bindingFormRules">
        <el-form-item :label="$t('bike.name2')" prop="ebikeModelId">
           <el-select v-model="bindingForm.ebikeModelId" :placeholder="$t('public.name1')">
              <el-option v-for="item in modelOptions" :key="item.ebikeModelId" :label="item.ebikeModelId" :value="item.ebikeModelId"> </el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="bindingVehicleMode" :loading='loading'>{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

      <!--分配运营商-->
    <el-dialog :title="$t('bike.name119')" :visible.sync="assignOperatorsDialog" v-if="assignOperatorsDialog" :close-on-click-modal ="false" :before-close="close" width="600px" >
      <el-form ref="assignOperatorsFormRef" label-width="120px" :model="assignOperatorsForm"   :rules="assignOperatorsFormRules">
        <el-form-item :label="$t('bike.name406')" prop="tenantId">
          <el-select v-model="assignOperatorsForm.tenantId" :placeholder="$t('public.name1')">
              <el-option v-for="item in tenantOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitAssignOperators" :loading='loading2'>{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

      <!--导入IOT-->
      <el-dialog :title="$t('bike.name158')" :visible.sync="iotDialog" v-if="iotDialog" :close-on-click-modal ="false" :before-close="close" width="600px" >
      <el-form ref="iotFormRef" label-width="150px" >
        <el-form-item :label="$t('bike.name100')">
          <a :href="importIotPath">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name102')" prop="fiveWayCodeFile" style="width:100%;">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>
         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadSectionFile3" :loading='loading2'>{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

     <!--版本配置-->
     <el-dialog :title="$t('bike.name118')" :visible.sync="versionConfigurationDialog" v-if="versionConfigurationDialog" :close-on-click-modal ="false" :before-close="close" width="600px">
      <el-form ref="versionConfigurationFormRef" label-width="120px" :model="versionConfigurationForm"  :rules="versionConfigurationFormRules">
        <el-form-item :label="$t('manage.name44')" prop="hardwareType">
            <el-select v-model="versionConfigurationForm.hardwareType" :placeholder="$t('public.name1')" @change="changeType">
              <el-option v-for="item in typeOptions" :key="item.name" :label="item.label" :value="item.name"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('bike.name21')" prop="otaFirewareInfoId">
            <el-select v-model="versionConfigurationForm.otaFirewareInfoId" :placeholder="$t('public.name1')">
              <el-option v-for="item in versionNumberOptions" :key="item.name" :label="item.id" :value="item.name"> </el-option>
            </el-select>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitVersionConfiguration" :loading="loading2">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

      <!--导入五通码-->
      <el-dialog title="五通码上传" :visible.sync="fiveWayCodeUploadDialog" v-if="fiveWayCodeUploadDialog" :close-on-click-modal ="false" :before-close="close" width="600px">
      <el-form label-width="150px">
        <el-form-item label="五通码模板下载：">
          <a href="https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E4%BA%94%E9%80%9A%E7%A0%81EXCEL%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx?Expires=2365230403&OSSAccessKeyId=ULZah0Yxq41iLeaf&Signature=gstHMnwITJS8aCNBItkF%2BYpURqQ%3D">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item label="五通码EXCEL上传：">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadSectionFile1" :loading="loading2">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

    <!--导入分配归属-->
    <el-dialog :title="$t('bike.name157')" :visible.sync="importIotNumDialog" v-if="importIotNumDialog" :close-on-click-modal ="false" :before-close="close" width="600px">
      <el-form label-width="150px" ref="importBelongFormRef"  :rules="importBelongFormRules"  :model="importBelong">
        <el-form-item :label="$t('bike.name100')">
          <a href="https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5IOT%E6%A8%A1%E7%89%88.xlsx">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name160')" prop="tenantId">
          <el-cascader ref="refHandle" v-model="importBelong.tenantId"  :show-all-levels="false" @change="handleChange" :props="{ lazy: true, checkStrictly: true, lazyLoad: loadOptions }" clearable></el-cascader>
        </el-form-item>
        <el-form-item :label="$t('bike.name102')" >
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadSectionFile2" :loading="loading2">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

    <!--分配归属-->
    <el-dialog :title="$t('bike.name156')" :visible.sync="addIotNumDialog" v-if="addIotNumDialog" :close-on-click-modal ="false" :before-close="close" width="600px">
      <el-form ref="belongFormRef"  label-width="150px" :rules="belongFormRules"  :model="belong">
        <el-form-item :label="$t('bike.name160')"  prop="tenantId">
            <el-cascader ref="refHandle" v-model="belong.tenantId"  :show-all-levels="false" @change="handleChange" :props="{ lazy: true, checkStrictly: true, lazyLoad: loadOptions }" clearable></el-cascader>
        </el-form-item>

        <!-- <el-form-item :label="$t('bike.name98')">
          <el-input v-model="queryInfo.loginName" :placeholder="$t('public.name5')" clearable> </el-input>
        </el-form-item> -->

        <!-- <el-form-item :label="$t('bike.name99')">
          <el-switch
            v-model="queryInfo.status"
            active-color="#0f73e6"
            inactive-color="#dcdfe6"
            active-value="1"
            inactive-value="0"
            :active-text="$t('bike.name45')"
            :inactive-text="$t('bike.name104')"
          >
          </el-switch>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitBelong" :loading="loading2">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>
     <!--车辆详情-->
     <el-dialog :title="$t('bike.name161')" :visible.sync="eBikeDetailsDialog" v-if="eBikeDetailsDialog" :before-close="close" width="1440px">
      <EBikeDetailsDialog ref="eBikeDetailsDialog" :e-bike-id="eBikeBaseInfo.ebikeId" :e-bike-code="eBikeBaseInfo.ebikeCode" :type="type"></EBikeDetailsDialog>
    </el-dialog>
      <!--修改车辆基本信息-->
      <el-dialog :title="$t('bike.name162')" :visible.sync="eBikeBaseInfoDialog" v-if="eBikeBaseInfoDialog" :close-on-click-modal ="false" :before-close="closeBaseInfoDialog" width="600px">
        <el-form label-width="120px" style="width:100%;" :model="eBikeBaseInfo">
          <!-- <el-form-item label="web配置：">
            <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="eBikeBaseInfo.webConfiguration">
          </el-input>
        </el-form-item> -->
        <el-form-item :label="$t('manage.name78')">
            <el-input
            type="textarea"
            :rows="3"
            maxlength="100"
            show-word-limit
            :placeholder="$t('public.name5')"
            v-model="eBikeBaseInfo.remark">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handlerDelBike" :loading="loading3" v-if="userinfo.tenantType === 0">{{ $t('bike.name253') }}</el-button>
        <el-button type="primary" @click="handlerModify" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeBaseInfoDialog">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

      <!--IOT详情-->
      <el-dialog :title="$t('bike.name254')" :visible.sync="iotDetailsDialog" v-if="iotDetailsDialog" :close-on-click-modal ="false" :before-close="close" width="1440px">
      <div class="top">
        <div>{{ ebikeId }}</div>
      </div>

      <div class="title-style">
        <el-divider></el-divider>
        <div class="title">{{ $t('bike.name255') }}</div>
        <el-divider></el-divider>
      </div>

      <el-form label-width="280px" style="width:100%;">
        <el-row>
          <el-col :span="8"><el-form-item :label="$t('bike.name256')">{{ iotDetails.username }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item :label="$t('bike.name257')">{{ iotDetails.connected ? '在线' : '离线' }} </el-form-item></el-col>
          <el-col :span="8"><el-form-item :label="$t('bike.name258')">{{ iotDetails.port }}</el-form-item></el-col>
        </el-row>

        <el-row>
          <el-col :span="8"><el-form-item :label="$t('bike.name259')">{{ iotDetails.node }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item :label="$t('bike.name260')">{{ iotDetails.ip_address }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item :label="$t('bike.name261')">{{ iotDetails.keepalive }}</el-form-item></el-col>
        </el-row>

        <el-row>
          <el-col :span="8"><el-form-item :label="$t('bike.name262')">{{ iotDetails.created_at }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item :label="$t('bike.name263')">{{ iotDetails.expiry_interval }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item :label="$t('bike.name264')">{{ iotDetails.connected_at }}</el-form-item></el-col>
        </el-row>

        <el-row>
          <el-col :span="8"><el-form-item :label="$t('bike.name265')">{{ iotDetails.send_pkt }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item :label="$t('bike.name266')">{{ iotDetails.recv_pkt }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item :label="$t('bike.name267')">{{ iotDetails.recv_cnt }}</el-form-item></el-col>
        </el-row>

        <el-row>
          <el-col :span="8"><el-form-item :label="$t('bike.name268')">{{ iotDetails.max_awaiting_rel }}</el-form-item></el-col>
          <el-col :span="8"><el-form-item :label="$t('bike.name269')">{{ iotDetails.max_inflight }}</el-form-item></el-col>
        </el-row>
      </el-form>
      <div class="title-style">
        <el-divider></el-divider>
        <div class="title">{{ $t('bike.name270') }}</div>
        <el-divider></el-divider>
      </div>
      <el-table :data="subscribeList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }">
      <el-table-column label="node" prop="node"  > </el-table-column>
      <el-table-column label="clientid" prop="clientid" ></el-table-column>
      <el-table-column label="qos" prop="qos" ></el-table-column>
      <el-table-column label="topic" prop="topic" ></el-table-column>
    </el-table>
    <div class="title-style">
        <el-divider></el-divider>
        <div class="title">{{ $t('bike.name271') }}</div>
        <el-divider></el-divider>
      </div>
      <div class='date-picker'>
        <el-date-picker
            v-model="searchTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')"
            :end-placeholder="$t('public.name11')"
          >
          </el-date-picker>
        <el-button type="primary" size="small" @click="getIotLog" class="search-bt" :loading="loading">{{ $t('public.name3') }}</el-button>
      </div>
      <div style="margin:15px;" v-html="iotLogInfo"></div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="modelFormtrue">确定</el-button> -->
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>
     <!--添加车辆-->
     <el-dialog :title="$t('bike.name3')" :visible.sync="addBikeDialog" v-if="addBikeDialog" :close-on-click-modal ="false" :before-close="closeAddBikeDialog" width="600px">
        <el-form label-width="160px" style="width:100%;" :model="addEBikeInfo" :rules="addBikeFormRules" ref="addBikeRef">
          <!-- <el-form-item :label="$t('bike.name160')"  prop="tenantId">
            <el-cascader ref="refHandle" :show-all-levels="false" style="width:80%"   @change="handleChange" :props="{ lazy: true, checkStrictly: true, lazyLoad: loadOptions }" clearable></el-cascader>
        </el-form-item> -->
        <el-form-item :label="$t('bike.name65')" prop="ebikeId">
            <el-input
            style="width:80%"
            :placeholder="$t('public.name5')"
            v-model="addEBikeInfo.ebikeId">
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="MAC地址：" prop="mac">
            <el-input
             style="width:80%"
            placeholder="请输入内容"
            v-model="addEBikeInfo.mac">
          </el-input>
        </el-form-item> -->
        <el-form-item :label="$t('bike.name379')" prop="testStatus">
          <el-switch class="switch" v-model="addEBikeInfo.testStatus"  active-color="#0f73e6" inactive-color="#dcdfe6"   :active-text="$t('bike.name252')"  :inactive-text="$t('bike.name251')"> </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handlerAddBike" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeAddBikeDialog">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

      <!--导入产品质量合格证-->
      <el-dialog :title="$t('bike.name213')" :visible.sync="productUploadDialog" v-if="productUploadDialog" :close-on-click-modal ="false" :before-close="closeProductUpload" width="600px">
      <el-form label-width="200px">
        <el-form-item :label="$t('bike.name100')">
          <a href="https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%90%88%E6%A0%BC%E8%AF%81-%E6%A8%A1%E6%9D%BF.xlsx">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name150')" prop="uploadTenantId">
          <el-select v-model="uploadTenantId" :placeholder="$t('public.name1')">
    <el-option
      v-for="item in manufacturerOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
          </el-form-item>
        <el-form-item :label="$t('bike.name405')">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadSectionFile4" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeProductUpload">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

     <!--导入车辆信息-->
     <el-dialog :title="$t('bike.name398')" :visible.sync="bikeUploadDialog" v-if="bikeUploadDialog" :close-on-click-modal ="false" :before-close="closeBikeUpload" width="600px">
      <el-form label-width="200px">
        <el-form-item :label="$t('bike.name100')">
          <a :href="importVehicleInformationPath">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name150')" prop="uploadTenantId">
          <el-select v-model="uploadTenantId" :placeholder="$t('public.name1')">
    <el-option
      v-for="item in manufacturerOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
          </el-form-item>
        <el-form-item :label="$t('bike.name404')">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadSectionFile5" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeBikeUpload">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>
     <!--导入车辆出厂信息-->
     <el-dialog :title="$t('bike.name400')" :visible.sync="bikeFactoryUploadDialog" v-if="bikeFactoryUploadDialog" :close-on-click-modal ="false" :before-close="closeBikeUpload" width="600px">
      <el-form label-width="200px">
        <el-form-item :label="$t('bike.name100')">
          <a :href="importVehicleFactoryInformationPath">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name150')" prop="uploadTenantId">
          <el-select v-model="uploadTenantId" :placeholder="$t('public.name1')">
    <el-option
      v-for="item in manufacturerOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
          </el-form-item>
        <el-form-item :label="$t('bike.name403')">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange" id="fileInput">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadSectionFile6" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeBikeUpload">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>
     <!--修改车辆出厂信息-->
     <el-dialog :title="$t('bike.name402')" :visible.sync="editEbikeInfoDialog" v-if="editEbikeInfoDialog" :close-on-click-modal ="false" :before-close="closeBikeUpload" width="600px">
      <el-form label-width="200px">
        <el-form-item :label="$t('bike.name100')">
          <a :href="modifyFactoryInformationPath">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name150')" prop="uploadTenantId">
          <el-select v-model="uploadTenantId" :placeholder="$t('public.name1')">
    <el-option
      v-for="item in manufacturerOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
          </el-form-item>
        <el-form-item :label="$t('bike.name403')">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange" id="fileInput">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadSectionFile7" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeBikeUpload">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

    <!--合格证-->
    <el-dialog :visible.sync="certificateDialog" v-if="certificateDialog" :close-on-click-modal ="false" :before-close="closeCertificateDialog" width="1440px">
      <CertificateDialog :certificate-details="certificateDetails"></CertificateDialog>
    </el-dialog>
  </div>
</template>
<script>
// import Cookies from 'js-cookie'
import {
  findEbikePage,
  bindModel,
  cancelBindModel,
  findEbikeDetail,
  getEbikePosture,
  sendTransportInfo,
  tenantBindEbike,
  importEbikeVin,
  importTenantBindEbike,
  importEbikeIdMacNoTenantId,
  modifyEbikeBaseInfo,
  findOtaFirmwarePage,
  findEbikeModelPage,
  otaFirmwareInfoList2,
  otaFirmwareInfoList3,
  sendUpgradeInfo,
  findIotStatusInfo,
  findIotSubscribeTopic,
  findIotCmdLog,
  exportEbike,
  removeIotEbike,
  addEbike,
  importEbikeBaseInfo,
  importCertificate,
  selecteById,
  importEbikeModelCertificateConformity,
  downloadTempFile,
  queryWebMaintainRecordListByEbikeId
} from '@/api/bike.js'
import { tenantList } from '@/api/manage.js'
import { downloadExcel } from '@/utils/utils'
import { mapGetters } from 'vuex'
import CertificateDialog from './certificateDialog.vue'
import EBikeDetailsDialog from '../components/eBikeDetailsDialog.vue'
export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  data() {
    return {
      activeName: 'first',
      modifyFactoryInformationPath: 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E4%BF%AE%E6%94%B9%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv2.xlsx',
      importIotPath: 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5IOT%E6%A8%A1%E7%89%88v2.xlsx',
      importVehicleFactoryInformationPath: 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv9.xlsx',
      importVehicleInformationPath: 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5%E8%BD%A6%E8%BE%86%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BF.xlsx',
      showBaseInfoType: 1,
      type: 1,
      certificateDetails: {},
      tenantIds2: [],
      certificateDialog: false,
      productUploadDialog: false,
      editEbikeInfoDialog: false,
      bikeUploadDialog: false,
      bikeFactoryUploadDialog: false,
      tenantIds: [],
      searchTime: null,
      iotDetailsDialog: false,
      eBikeBaseInfoDialog: false,
      iotDialog: false,
      eBikeBaseInfo: {
        ebikeId: '',
        ebikeCode: '',
        remark: ''
      },
      typeOptions: [],
      typeAllOptions: [
        { name: 0, label: 'IOT' },
        { name: 1, label: this.$t('bike.name14') },
        { name: 2, label: this.$t('bike.name413') }
      ],
      loading1: false,
      loading2: false,
      loading3: false,
      exportLoading: false,
      pageNumber: 1,
      pageSize: 10,
      alarmTotal: 0,
      alarmMessageList: [],
      subscribeList: [],
      importIotNumDialog: false,
      assignOperatorsDialog: false,
      versionConfigurationDialog: false,
      fiveWayCodeUploadDialog: false,
      eBikeDetailsDialog: false,
      eBikeDetails: {},
      iotDetails: {},
      addIotNumDialog: false,
      vehicleModelBindingDialog: false,
      tenantOptions: [],
      manufacturerOptions: [],
      modelOptions: [],
      bindingForm: {
        ebikeModelId: '',
        ebikeIdList: []
        // ebikeVinNo: ''
      },
      fileList: [],
      belong: {
        tenantId: []
      },
      belongFormRules: {
        tenantId: [
          {
            required: true,
            message: this.$t('public.name45'),
            trigger: 'blur'
          }
        ]
      },
      importBelong: {
        tenantId: []
      },
      importBelongFormRules: {
        tenantId: [
          {
            required: true,
            message: this.$t('public.name45'),
            trigger: 'blur'
          }
        ]
      },
      statusOptions: [
        {
          value: '1',
          label: this.$t('bike.name45')
        },
        {
          value: '0',
          label: this.$t('bike.name113')
        }
      ],
      bindingFormRules: {
        ebikeModelId: [
          {
            required: true,
            message: this.$t('bike.name468'),
            trigger: 'blur'
          }
        ]
      },
      assignOperatorsForm: {
        tenantId: ''
      },
      assignOperatorsFormRules: {
        tenantId: [
          {
            required: true,
            message: this.$t('bike.name469'),
            trigger: 'blur'
          }
        ]
      },
      versionConfigurationForm: {
        hardwareType: '',
        otaFirewareInfoId: '',
        ebikeIdList: []
      },
      versionConfigurationFormRules: {
        otaFirewareInfoId: [
          {
            required: true,
            message: this.$t('bike.name470'),
            trigger: 'blur'
          }
        ],
        hardwareType: [
          {
            required: true,
            message: this.$t('bike.name471'),
            trigger: 'blur'
          }
        ]
      },
      queryInfo: {
        status: '',
        pageNumber: 1,
        pageSize: 10,
        ebikeId: '',
        ebikeCode: '',
        controllerEdition: '',
        meterEdition: '',
        iotEdition: '',
        permTenantList: [],
        bluetoothFlag: '1'
      },
      bluetoothFlag: '1',
      tableLoading: false,
      loading: false,
      selectionList: [],
      total: 0,
      tableList: [],
      options: [],
      ridelist: [
        {
          bikeCode: '',
          email: '',
          remark: '',
          ebikeId: '',
          type: '',
          bikeMac: '',
          status: '',
          isTransport: '',
          controllerEdition: '',
          meterEdition: '',
          iotEdition: '',
          ebikeModelId: '',
          ebikeModelName: '',
          motorNo: '',
          ebikeVinNo: ''
        }
      ],
      isTransportlist: [],

      // 详情提示框
      ebikeId: '',
      dialogBikeInfoVisible: false,
      IOTebikeId: '',
      dialogIoTisible: false,
      // 延迟
      // 车型绑定
      modelist: [],
      modelVisible: false,
      modelFrom: {
        ebikeModelId: '',
        ebikeId: [],
        ebikeVinNo: ''
      },
      modelFromRules: {
        ebikeModelId: [
          {
            required: true,
            message: this.$t('bike.name472'),
            trigger: 'blur'
          }
        ]
      },
      // OTA升级
      selectlist: [],
      disposeOTAVisible: false,
      disposeOTAFrom: {
        ebikeId: [],
        hardwareType: '',
        versionNumber: ''
      },
      versionNumberOptions: [],
      TypefirmwareList: [],
      fiveWayCodeFile: null,
      ImportbikeVisible: false,
      buttonPerms: '',
      tenantAllOptions: [],
      iotLogInfo: '',
      timer: null,
      addBikeDialog: false,
      addEBikeInfo: {
        tenantId: '',
        ebikeId: '',
        mac: '',
        testStatus: true
      },
      maintenanceRecordList: [],
      maintenanceRecordTotal: 0,
      maintenanceRecord: {
        pageNumber: 1,
        pageSize: 10
      },
      spanArr: [],
      pos: 0,
      uploadTenantId: '',
      addBikeFormRules: {
        // tenantId: [
        //   {
        //     required: true,
        //     message: '请选择任意一级',
        //     trigger: 'blur'
        //   }
        // ],
        ebikeId: [
          {
            required: true,
            message: this.$t('bike.name473'),
            trigger: 'blur'
          }
        ],
        // mac: [
        //   {
        //     required: true,
        //     message: '请输入MAC地址',
        //     trigger: 'blur'
        //   }
        // ],
        testStatus: [
          {
            required: true,
            message: this.$t('public.name1'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  components: {
    CertificateDialog,
    EBikeDetailsDialog
  },
  created () {
    const lang = localStorage.getItem('lang')
    if (lang === 'en') {
        this.modifyFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/Modify%20the%20factory%20information%20of%20the%20vehicle%20.xlsx'
        this.importIotPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/Import%20IOT.xlsx'
        this.importVehicleFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/Import%20the%20vehicle%27s%20factory%20information.xlsx'
        this.importVehicleInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/Import%20vehicle%20information.xlsx'
      } else {
        this.modifyFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E4%BF%AE%E6%94%B9%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv1.xlsx'
        this.importIotPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5IOT%E6%A8%A1%E7%89%88v2.xlsx'
        this.importVehicleFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv8.xlsx'
        this.importVehicleInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5%E8%BD%A6%E8%BE%86%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BF.xlsx'
      }
    this.buttonPerms = localStorage.getItem('buttonPerms')
  },
  beforeDestroy() {
    this.$bus.$off('lang')
  },
  mounted() {
    this.$bus.$on('lang', (lang) => {
      if (lang === 'en') {
        this.modifyFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/Modify%20the%20factory%20information%20of%20the%20vehicle%20.xlsx'
        this.importIotPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/Import%20IOT.xlsx'
        this.importVehicleFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/Import%20the%20vehicle%27s%20factory%20information.xlsx'
        this.importVehicleInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/Import%20vehicle%20information.xlsx'
      } else {
        this.modifyFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E4%BF%AE%E6%94%B9%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv1.xlsx'
        this.importIotPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5IOT%E6%A8%A1%E7%89%88v2.xlsx'
        this.importVehicleFactoryInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5%E8%BD%A6%E8%BE%86%E5%87%BA%E5%8E%82%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BFv8.xlsx'
        this.importVehicleInformationPath = 'https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5%E8%BD%A6%E8%BE%86%E4%BF%A1%E6%81%AF-%E6%A8%A1%E6%9D%BF.xlsx'
      }
    })
    this.getBikeList()
    this.getTenantList()
    this.getEbikeModelList()
    // this.getOtaFirmwareInfoLlist2()
    this.loadOptions1()
  },
  methods: {
    handleClick() {
      if (this.activeName === 'first') {
        this.bluetoothFlag = '1'
      } else {
        this.bluetoothFlag = '0'
      }
      this.queryInfo.pageNumber = 1
      this.queryInfo.bluetoothFlag = this.bluetoothFlag
      this.getBikeList()
    },
    resetQuery() {
      this.queryInfo = {
        status: '',
        pageNumber: 1,
        pageSize: 10,
        ebikeId: '',
        controllerEdition: '',
        meterEdition: '',
        iotEdition: '',
        permTenantList: []
      }
      this.tenantIds = []
      this.getBikeList()
    },
    exportEbikeData() {
      this.exportLoading = true
      this.queryInfo.ebikeId = this.queryInfo.ebikeId.trim()
      // console.log('queryInfo=====', this.queryInfo)
      // this.queryInfo.controllerEdition = this.queryInfo.controllerEdition.trim()
      // this.queryInfo.meterEdition = this.queryInfo.meterEdition.trim()
      // this.queryInfo.iotEdition = this.queryInfo.iotEdition.trim()
      exportEbike(this.queryInfo).then(res => {
        this.exportLoading = false
        downloadExcel(res, this.$t('bike.name229'))
      }).catch(() => {
        this.exportLoading = false
      })
    },
    getEbikeModelList() {
      const queryInfo = {
        pageNumber: 1,
        pageSize: 500
      }
      findEbikeModelPage(queryInfo).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.modelOptions = res.data.ebikeModelPage.records
        }
      })
    },
    getTenantList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 2
      }
      tenantList(data)
        .then(res => {
          this.tenantOptions = res.data.list
        })
        .catch(() => {
          this.tenantOptions = []
        })
    },
    showImportIotNum() {
      this.importIotNumDialog = true
    },
    showAddIotNum() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      this.addIotNumDialog = true
    },
    showAssignOperatorsDialog() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      this.assignOperatorsDialog = true
    },
    showVersionConfigurationDialog() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      this.versionConfigurationDialog = true
    },
    showFiveCodeDialog() {
      this.fiveWayCodeUploadDialog = true
    },
    showDetailsDialog(row) {
      console.log('ebikeCode====', row)
      this.eBikeBaseInfo.ebikeId = row.ebikeId
      this.eBikeBaseInfo.ebikeCode = row.ebikeCode
      // this.getBikeDetails()
      // this.getMaintainRecordList(row.ebikeId)
      // this.showBaseInfoType = 1
      this.eBikeDetailsDialog = true
      // this.timer = setInterval(this.getBikeDetails, 5000)
    },
    getBikeDetails() {
      getEbikePosture({ ebikeId: this.eBikeBaseInfo.ebikeId, pageSize: this.pageSize, pageNumber: this.pageNumber }).then(res => {
        if (res.code === 200) {
          this.alarmMessageList = res.data.ebikePosturePage.records
          this.alarmTotal = res.data.ebikePosturePage.total
        }
      })
      findEbikeDetail({ ebikeId: this.eBikeBaseInfo.ebikeId }).then(res => {
        if (res.code === 200) {
          this.eBikeDetails = res.data.iotEbike
        }
      })
    },
    showBaseInfo(type) {
      this.showBaseInfoType = type
    },
    showBaseInfoDialog() {
      this.eBikeBaseInfoDialog = true
    },
    handlerDelBike() {
      this.$confirm(this.$t('bike.name381'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          removeIotEbike({ ebikeId: this.eBikeBaseInfo.ebikeId }).then((res) => {
            if (res.code === 200) {
              this.closeBaseInfoDialog()
              this.eBikeDetailsDialog = false
              clearInterval(this.timer)
              this.timer = null
              this.getPageList()
              this.$message({ type: 'success', message: this.$t('public.name30') })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name31')
          })
        })
    },
    handlerModify() {
      this.loading3 = true
      modifyEbikeBaseInfo(this.eBikeBaseInfo)
        .then((res) => {
          this.loading3 = false
          if (res.code === 200) {
            findEbikeDetail({ ebikeId: this.eBikeBaseInfo.ebikeId }).then((res) => {
              if (res.code === 200) {
                this.eBikeDetails = res.data.iotEbike
              }
            })
            this.closeBaseInfoDialog()
          }
        })
        .catch(() => {
          this.loading3 = false
        })
    },
    closeBaseInfoDialog() {
      this.eBikeBaseInfoDialog = false
      this.eBikeBaseInfo.remark = ''
      // this.pageSize = 10
      // this.pageNumber = 1
      // this.alarmTotal = 0
      // this.alarmMessageList = []
    },
    showIotDetailsDialog(row) {
      this.iotDetailsDialog = true
      this.ebikeId = row.ebikeId
      this.getIOTDetails()
      this.timer = setInterval(this.getIOTDetails, 10000)
    },

    getIOTDetails() {
      findIotStatusInfo({ ebikeId: this.ebikeId })
        .then((res) => {
          if (res.code === 200) {
            this.iotDetails = res.data.iotStatusInfo || {}
          }
        })
        .catch(() => {
        })
      findIotSubscribeTopic({ ebikeId: this.ebikeId })
        .then((res) => {
          if (res.code === 200) {
            this.subscribeList = res.data.topic
          }
        })
        .catch(() => {
          this.subscribeList = []
        })
    },
    submitVersionConfiguration() {
      this.$refs.versionConfigurationFormRef.validate((valid) => {
        if (valid) {
          this.loading2 = true
          this.versionConfigurationForm.ebikeIdList = []
          this.selectionList.map((item, index) => {
            this.versionConfigurationForm.ebikeIdList.push(item.ebikeId)
          })
          sendUpgradeInfo(this.versionConfigurationForm)
            .then((res) => {
              this.loading2 = false
              if (res.code === 200) {
                this.$refs.table.clearSelection()
                this.close()
                this.getBikeList()
              }
            })
            .catch(() => {
              this.loading2 = false
            })
        } else {
          return false
        }
      })
    },
    submitAssignOperators() {
      this.$refs.assignOperatorsFormRef.validate(valid => {
        if (valid) {
          this.loading2 = true
          const ebikeIdList = []
          this.selectionList.map((item, index) => {
            ebikeIdList.push(item.ebikeId)
          })
          tenantBindEbike({ ebikeIdList: ebikeIdList, tenantId: this.assignOperatorsForm.tenantId })
            .then(res => {
              this.loading2 = false
              if (res.code === 200) {
                this.$refs.table.clearSelection()
                this.close()
                this.getBikeList()
              }
            })
            .catch(() => {
              this.loading2 = false
            })
        } else {
          return false
        }
      })
    },
    submitBelong() {
      this.$refs.belongFormRef.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('public.name32'), this.$t('public.name23'), {
            confirmButtonText: this.$t('public.name25'),
            cancelButtonText: this.$t('public.name14'),
            type: 'warning'
          })
            .then(() => {
              this.loading2 = true
              const ebikeIdList = []
              this.selectionList.map((item, index) => {
                ebikeIdList.push(item.ebikeId)
              })
              tenantBindEbike({ ebikeIdList: ebikeIdList, tenantId: this.belong.tenantId })
                .then((res) => {
                  this.loading2 = false
                  if (res.code === 200) {
                    this.$refs.table.clearSelection()
                    this.close()
                    this.getBikeList()
                  }
                })
                .catch(() => {
                  this.loading2 = false
                })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('public.name33')
              })
            })
        } else {
          return false
        }
      })
    },
    changeTransportMode() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      if (this.selectionList.length > 1) {
        this.$message.warning(this.$t('bike.name382'))
        return
      }
      const ebikeIdList = []
      this.selectionList.map((item, index) => {
        ebikeIdList.push(item.ebikeId)
      })
      this.$confirm(this.$t('bike.name383'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          this.loading1 = true
          sendTransportInfo({ ebikeId: ebikeIdList[0] })
            .then(res => {
              this.loading1 = false
              if (res.code === 200) {
                this.$refs.table.clearSelection()
                this.getBikeList()
              }
            })
            .catch(() => {
              this.loading1 = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name34')
          })
        })
    },
    close() {
      if (this.$refs.eBikeDetailsDialog) {
        this.$refs.eBikeDetailsDialog.close()
      }
      this.vehicleModelBindingDialog = false
      this.assignOperatorsDialog = false
      this.assignOperatorsForm = {
        tenantId: ''
      }
      this.versionConfigurationDialog = false
      this.fiveWayCodeUploadDialog = false
      this.eBikeDetailsDialog = false
      this.bindingForm = {
        ebikeModelId: '',
        ebikeIdList: []
      }
      this.importIotNumDialog = false
      this.addIotNumDialog = false
      this.belong = {
        tenantId: ''
      }
      this.importBelong = {
        tenantId: ''
      }
      this.versionConfigurationForm = {
        hardwareType: '',
        otaFirewareInfoId: '',
        ebikeIdList: []
      }
      this.versionConfigurationDialog = false
      this.searchTime = null
      this.iotLogInfo = ''
      this.iotDetailsDialog = false
      this.iotDialog = false
      clearInterval(this.timer)
      this.timer = null
    },
    getPageList() {
      this.queryInfo.pageSize = 10
      this.queryInfo.pageNumber = 1
      this.getBikeList()
    },

    getBikeList() {
      this.tableLoading = true
      this.queryInfo.ebikeId = this.queryInfo.ebikeId.trim()
      this.queryInfo.controllerEdition = this.queryInfo.controllerEdition.trim()
      this.queryInfo.meterEdition = this.queryInfo.meterEdition.trim()
      this.queryInfo.iotEdition = this.queryInfo.iotEdition.trim()
      findEbikePage(this.queryInfo).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.tableList = res.data.page.records
          this.total = res.data.page.total
        }
      }).catch(() => {
        this.tableLoading = false
      })
    },
    showModeBindDialog() {
      if (this.selectionList.length > 0) {
        this.selectionList.map((item, index) => {
          this.bindingForm.ebikeIdList.push(item.ebikeId)
        })
        this.vehicleModelBindingDialog = true
      } else {
        this.$message.warning(this.$t('bike.name380'))
      }
    },
    bindingVehicleMode() {
      this.$refs.bindingFormRef.validate(valid => {
        if (valid) {
          this.loading = true
          bindModel(this.bindingForm).then(res => {
            this.loading = false

            console.log('===', res.code)
            if (res.code === 200) {
              this.getBikeList()
              this.$refs.table.clearSelection()
              this.close()
            }
          }).catch(() => {
            this.loading = false
          })
          this.close()
        } else {
          return false
        }
      })
    },
    handleCancelBindModel(row) {
      this.$confirm(this.$t('bike.name384'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          cancelBindModel({ ebikeIdList: [row.ebikeId] }).then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: this.$t('bike.name385')
              })
              this.queryInfo.pageNumber = 1
              this.getBikeList()
            }
          }).catch(() => {})
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('bike.name386')
          })
        })
    },
    onSelectTab(selection) {
      this.selectionList = selection
    },
    loadOptions(node, resolve) {
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }
      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }
      if (node.level === 2) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 3,
          parentId: node.value
        }
      }
      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 2
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => {})
    },
    loadOptions1() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }
      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName
            }))
            this.manufacturerOptions = options
            this.uploadTenantId = this.manufacturerOptions[0].value
          } else {
            this.manufacturerOptions = []
          }
        })
        .catch(() => {})
    },
    versionLoadOptions(node, resolve) {
      console.log('====', node)
      let data = {
        pageNumber: 1,
        pageSize: 500
      }
      if (node.level === 1) {
        data = {
          pageNumber: 1,
          pageSize: 500,
          tenantId: node.value
        }
      }
      if (node.level === 2) {
        data = {
          pageNumber: 1,
          pageSize: 500,
          parentId: node.value
        }
      }
      findOtaFirmwarePage(data).then((res) => {
        var options = []
        if (node.level === 0) {
          options = res.data.page.records.map((item) => ({ value: item.tenantId, label: item.tenantName, leaf: node.level >= 2 }))
        }
        if (node.level === 1) {
          options = res.data.page.records.map((item) => ({ value: item.firmwareType, label: ['IOT', this.$t('bike.name14'), this.$t('bike.name413')][item.firmwareType], leaf: node.level >= 2 }))
        }
        resolve(options)
      }).catch(() => {})
    },
    handleVersionChange(value) {},
    handleChange(value) {
      console.log('value===', value)
      // 处理选项变化
      this.belong.tenantId = value[value.length - 1]
      this.importBelong.tenantId = value[value.length - 1]
      // this.addEBikeInfo.tenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    handleChange1(value) {
      console.log('value===', value)
      // 处理选项变化
      this.queryInfo.permTenantList = []
      if (value.length > 0) {
        value.map((item) => {
          this.queryInfo.permTenantList.push(item[item.length - 1])
        })
      }
      console.log('value===', this.queryInfo.permTenantList)
      // const panelRefs = this.$refs.refHandle.$refs.panel
      // if (panelRefs.activePath.length !== 0) {
      //   panelRefs.activePath.forEach(item => {
      //     if (item.children.length === 0) {
      //       panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      //     }
      //   })
      // }
      this.getPageList()
    },
    handleUpLoadFile(param) {
      const formData = new FormData()
      formData.append('file', param.file)
      const loading = this.$loading({
        lock: true,
        text: this.$t('public.name35'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      importEbikeIdMacNoTenantId(formData)
        .then(res => {
          loading.close()
          downloadExcel(res, this.$t('bike.name387'))
          this.getBikeList()
        })
        .catch(res => {
          loading.close()
        })
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getBikeList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.getBikeList()
    },
    // 监听pagesizes的事件
    handleAlarmSizeChange(newSize) {
      this.pageSize = newSize
      getEbikePosture({ ebikeId: this.eBikeBaseInfo.ebikeId, pageSize: this.pageSize, pageNumber: this.pageNumber }).then(res => {
        if (res.code === 200) {
          this.alarmMessageList = res.data.ebikePosturePage.records
          this.alarmTotal = res.data.ebikePosturePage.total
        }
      })
      // this.getBikeList()
    },
    // 监听页码值改变事件
    handleAlarmCurrentChange(newPage) {
      this.pageNumber = newPage
      // this.getBikeList()
      getEbikePosture({ ebikeId: this.eBikeBaseInfo.ebikeId, pageSize: this.pageSize, pageNumber: this.pageNumber }).then(res => {
        if (res.code === 200) {
          this.alarmMessageList = res.data.ebikePosturePage.records
          this.alarmTotal = res.data.ebikePosturePage.total
        }
      })
    },

    // 导入五通码
    Importbike() {
      this.ImportbikeVisible = true
    },
    ImportbikeDialogBefore() {
      this.ImportbikeVisible = false
    },
    // uploadFile(file) {
    //   this.fiveWayCodeFile = file
    // },
    delFile() {
      this.fiveWayCodeFile = null
    },
    handleBeforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error(this.$t('public.name36'))
        return false
      }
      return true
    },
    handleManualUpload() {
      this.$refs.fileInput.click()
    },
    handleFileChange(e) {
      this.fiveWayCodeFile = e.target.files[0]
      e.target.value = ''
    },
    uploadSectionFile1() {
      if (this.fiveWayCodeFile === null) {
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      this.loading2 = true
      importEbikeVin(formData)
        .then(res => {
          this.loading2 = false
          if (res.code === 200) {
            this.$message.success(this.$t('bike.name388'))
          } else {
            this.$confirm(this.$t('bike.name389'), this.$t('public.name23'), {
              confirmButtonText: this.$t('public.name37'),
              cancelButtonText: this.$t('public.name14'),
              type: 'warning'
            }).then(() => {
              downloadExcel(res, this.$t('bike.name390'))
            }).catch(() => {})
          }
          this.$refs.table.clearSelection()
          this.getPageList()
          this.fiveWayCodeUploadDialog = false
          this.fiveWayCodeFile = null
        })
        .catch(res => {
          this.loading2 = false
        })
    },
    uploadSectionFile2() {
      if (this.fiveWayCodeFile === null) {
        this.$message.error(this.$t('public.name38'))
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      formData.append('tenantId', this.importBelong.tenantId)
      this.loading2 = true
      importTenantBindEbike(formData)
        .then(res => {
          this.loading2 = false
          if (res.code === 200) {
            // console.log('res====2', res)
            if (res.data) {
              downloadTempFile({ objectName: res.data })
                .then((res) => {
                  this.$confirm(this.$t('bike.name389'), this.$t('public.name23'), {
                    confirmButtonText: this.$t('public.name37'),
                    cancelButtonText: this.$t('public.name14'),
                    type: 'warning'
                  })
                    .then(() => {
                      downloadExcel(res, this.$t('bike.name387'))
                    })
                    .catch(() => {})
                })
                .catch((res) => {})
            } else {
              this.$message.success(this.$t('bike.name391'))
            }
          }
          this.$refs.table.clearSelection()
          this.getPageList()
          this.importIotNumDialog = false
          this.importBelong.tenantId = ''
          this.fiveWayCodeFile = null
        })
        .catch(res => {
          this.loading2 = false
        })
    },
    showIOTDialog() {
      this.iotDialog = true
    },
    uploadSectionFile3() {
      if (this.fiveWayCodeFile === null) {
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      this.loading2 = true
      importEbikeIdMacNoTenantId(formData)
        .then(res => {
          this.loading2 = false
          // console.log('res====1', res)
          if (res.code === 200) {
            if (res.data) {
              downloadTempFile({ objectName: res.data })
                .then((res) => {
                  this.$confirm(this.$t('bike.name389'), this.$t('public.name23'), {
                    confirmButtonText: this.$t('public.name37'),
                    cancelButtonText: this.$t('public.name14'),
                    type: 'warning'
                  })
                    .then(() => {
                      downloadExcel(res, this.$t('bike.name387'))
                    })
                    .catch(() => {})
                })
                .catch((res) => {})
            } else {
              this.$message.success(this.$t('bike.name391'))
            }
          }
          this.getPageList()
          this.iotDialog = false
          this.fiveWayCodeFile = null
        })
        .catch(res => {
          this.loading2 = false
        })
    },

    blobDownload(data) {
      if (!data) {
        return
      }
      const name = '五通码检验结果'
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(data, name)
      } else {
        const blob = new Blob([data.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
        URL.revokeObjectURL(url)
      }
    },
    onUploadSuccess() {
      this.$message.success('文件上传成功，请查看下载结果')
      this.$refs.uploadss.clearFiles()
      this.ImportbikeVisible = false
      this.getBikes()
    },
    beforebikeupload(file) {
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      const size = file.size / 1024 / 1024
      if (size > 50) {
        this.$message.warning('文件大小不得超过50M')
        return false
      }
      if (extension !== 'xlsx') {
        this.$message.warning('只能上传后缀是.xlsx的文件')
        return false
      }
    },
    getOtaFirmwareInfoLlist2() {
      const data = {
        tenantId: this.userinfo.tenantId
      }
      otaFirmwareInfoList2(data)
        .then((res) => {
          res.data.map((item) => {
            this.typeAllOptions.map((items) => {
              if (item === items.name) {
                const obj = {}
                obj.name = items.name
                obj.label = items.label
                this.typeOptions.push(obj)
              }
            })
          })
        })
        .catch(() => {
          this.typeOptions = []
        })
    },
    changeType(e) {
      const data = {
        tenantId: this.userinfo.tenantId,
        firmwareType: e
      }
      otaFirmwareInfoList3(data)
        .then((res) => {
          this.versionNumberOptions = res.data
        })
        .catch(() => {
          this.versionNumberOptions = []
        })
    },
    getIotLog() {
      if (this.searchTime) {
        this.loading = true
        findIotCmdLog({ startTime: this.searchTime[0], endTime: this.searchTime[1], ebikeId: this.ebikeId, wrap: '</br>' }).then((res) => {
          if (res.data.iotLogInfo) {
            this.iotLogInfo = res.data.iotLogInfo
          } else {
            this.iotLogInfo = this.$t('public.name39')
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      }
    },
    showAddBikeDialog() {
      this.addBikeDialog = true
    },
    closeAddBikeDialog() {
      this.addBikeDialog = false
      this.addEBikeInfo = {
        tenantId: '',
        ebikeId: '',
        mac: '',
        testStatus: true
      }
    },
    handlerAddBike() {
      this.$refs.addBikeRef.validate(valid => {
        if (valid) {
          this.loading3 = true
          // if (Array.isArray(this.addEBikeInfo.tenantId)) {
          //   this.addEBikeInfo.tenantId = this.addEBikeInfo.tenantId[0]
          // }
          addEbike(this.addEBikeInfo).then(res => {
            this.loading3 = false
            if (res.code === 200) {
              this.getBikeList()
              this.closeAddBikeDialog()
            }
          }).catch(() => {
            this.loading3 = false
          })
        } else {
          return false
        }
      })
    },
    importProductDialog() {
      this.productUploadDialog = true
    },
    closeProductUpload() {
      this.productUploadDialog = false
      this.tenantIds2 = []
    },
    handleChange2(value) {
      // 处理选项变化
      this.uploadTenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle2.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    uploadSectionFile4() {
      if (this.fiveWayCodeFile === null && this.uploadTenantId !== '') {
        this.$message.error(this.$t('bike.name392'))
        return
      }
      const formData = new FormData()
      formData.append('tenantId', this.uploadTenantId)
      formData.append('file', this.fiveWayCodeFile)
      this.loading2 = true
      importCertificate(formData)
        .then(res => {
          this.loading2 = false
          if (res.code === 200) {
            this.$message.success(this.$t('bike.name393'))
          } else {
            this.$confirm(this.$t('bike.name394'), this.$t('public.name23'), {
              confirmButtonText: this.$t('public.name37'),
              cancelButtonText: this.$t('public.name14'),
              type: 'warning'
            }).then(() => {
              downloadExcel(res, this.$t('bike.name395'))
            }).catch(() => {})
          }
          this.getPageList()
          this.productUploadDialog = false
          this.fiveWayCodeFile = null
          this.tenantIds2 = []
          this.uploadTenantId = this.manufacturerOptions[0].value
        })
        .catch(res => {
          this.loading2 = false
        })
    },
    importBikeInfoDialog() {
      this.bikeUploadDialog = true
    },
    importBikeFactoryDialog() {
      this.bikeFactoryUploadDialog = true
    },
    closeBikeUpload() {
      this.bikeUploadDialog = false
      this.bikeFactoryUploadDialog = false
      this.tenantIds2 = []
    },
    uploadSectionFile5() {
      if (this.fiveWayCodeFile === null && this.uploadTenantId !== '') {
        this.$message.error(this.$t('bike.name392'))
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      formData.append('tenantId', this.uploadTenantId)
      this.loading3 = true
      importEbikeBaseInfo(formData)
        .then(res => {
          this.loading3 = false
          if (res.code === 200) {
            this.$message.success(this.$t('bike.name396'))
          } else {
            this.$confirm(this.$t('bike.name397'), this.$t('public.name23'), {
              confirmButtonText: this.$t('public.name37'),
              cancelButtonText: this.$t('public.name14'),
              type: 'warning'
            }).then(() => {
              downloadExcel(res, this.$t('bike.name398'))
            }).catch(() => {})
          }
          this.$refs.table.clearSelection()
          this.getPageList()
          this.bikeUploadDialog = false
          this.tenantIds2 = []
          this.uploadTenantId = this.manufacturerOptions[0].value
          this.fiveWayCodeFile = null
        })
        .catch(res => {
          this.loading3 = false
        })
    },
    uploadSectionFile6() {
      if (this.fiveWayCodeFile === null && this.uploadTenantId !== '') {
        this.$message.error(this.$t('bike.name392'))
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      formData.append('tenantId', this.uploadTenantId)
      this.loading3 = true
      importEbikeModelCertificateConformity(formData)
        .then((res) => {
          this.loading3 = false
          if (res.code === 200) {
            if (res.data) {
              downloadTempFile({ objectName: res.data })
                .then((res) => {
                  this.$confirm(this.$t('bike.name399'), this.$t('public.name23'), {
                    confirmButtonText: this.$t('public.name37'),
                    cancelButtonText: this.$t('public.name14'),
                    type: 'warning'
                  })
                    .then(() => {
                      downloadExcel(res, this.$t('bike.name400'))
                    })
                    .catch(() => {})
                })
                .catch((res) => {})
            } else {
              this.$message.success(this.$t('bike.name401'))
            }
          }
          this.$refs.table.clearSelection()
          this.getPageList()
          this.bikeFactoryUploadDialog = false
          this.tenantIds2 = []
          this.uploadTenantId = this.manufacturerOptions[0].value
          this.fiveWayCodeFile = null
        })
        .catch((res) => {
          this.loading3 = false
        })
    },
    showCertificateDialog(row) {
      selecteById({ id: row.eccId })
        .then(res => {
          this.certificateDetails = res.data || {}
        })
        .catch(res => {
          this.certificateDetails = {}
        })
      this.certificateDialog = true
    },
    closeCertificateDialog() {
      this.certificateDialog = false
    },
    getMaintainRecordList(ebikeId) {
      queryWebMaintainRecordListByEbikeId({ ebikeId: ebikeId })
        .then((res) => {
          if (res.code === 200) {
            this.maintenanceRecordList = res.data
            this.pos = 0
            this.spanArr = []
            this.getSpanArr(this.maintenanceRecordList)
          }
        })
        .catch(() => {
        })
    },
    getSpanArr(data) {
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1)
          this.pos = 0
        } else {
          // 判断当前元素与上一个元素是否相同
          if (
            data[i].id === data[i - 1].id &&
            data[i].tenantName === data[i - 1].tenantName &&
            data[i].createTime === data[i - 1].createTime &&
            data[i].storeAddress === data[i - 1].storeAddress
          ) {
            this.spanArr[this.pos] += 1
            this.spanArr.push(0)
          } else {
            this.spanArr.push(1)
            this.pos = i
          }
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 6) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
          rowspan: _row,
          colspan: _col
        }
      }
    }
    // handleMaintenanceSizeChange(newSize) {
    //   this.maintenanceRecord.pageSize = newSize
    //   this.getMaintainRecordList()
    // },
    // handleMaintenanceChange(newPage) {
    //   this.maintenanceRecord.pageNumber = newPage
    //   this.getMaintainRecordList()
    // }
  }
}
</script>
<style lang="scss">
.switch .el-switch__label {
  position: absolute;
  display: none;
  color: #fff !important;
}

/*打开时文字位置设置*/
.switch .el-switch__label--right {
  z-index: 1;
}

/* 调整打开时文字的显示位子 */
.switch .el-switch__label--right span {
  margin-left: 9px;
}

/*关闭时文字位置设置*/
.switch .el-switch__label--left {
  z-index: 1;
}

/* 调整关闭时文字的显示位子 */
.switch .el-switch__label--left span {
  margin-left: 22px;
}

/*显示文字*/
.switch .el-switch__label.is-active {
  display: block;
}

/* 调整按钮的宽度 */
.switch.el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 50px !important;
  margin: 0;
}

</style>

<style lang="scss" scoped>
.bikelist-container {
  display: flex;
  flex-direction: column;
  .top{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .add-user{
    display: flex;
    flex-direction: row;
  }

  .title-style{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title{
      width: 50%;
      text-align: center;
    }
  }

  .date-picker{
    display: flex;
    flex-direction: row;
   .search-bt{
      margin-left: 25px;
    }
  }

  .file-list{
    width: 70%;
    display: flex;
    justify-content: space-between;
    margin-top: -25px;

    .el-icon-close{
      font-size: 18px;
    }
  }

  .green {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;
  }

  .red {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;
  }
}
</style>
